<template>
  <div v-if='isGrid || isList' class='properties-listing'>
    <div class='default-content'>
      <div v-if='properties && properties.length' class='properties-listing__area' :class="{ 'list-view': isList }">
        <div class='properties-item' v-for='property in properties'>
          <!--                <span class="properties__label" v-if="property.status && property.status.attribute.slug!=='active'" :style='"background-image:url(\"/images/label-"+property.status.attribute.slug+"-"+lang+"-" + site + ".png\");"'/>-->
          <div class='properties-item__image-holder'>
            <img v-if='property.listingMainPhoto' class='properties-item__image' :src='property.listingMainPhoto'/>
          </div>
          <div class='properties-item__info'>
            <div class='properties-item__heading'>
              <div class='properties-item__title'>
                <div class='properties-item__address'>{{ property.postcode }}, {{ property.location && property.location.name }}</div>
                <div class='properties-item__name'>{{ property.listingAddressIn }}</div>
              </div>
              <template v-if='this.location.href.indexOf("staffhousing")==-1 && property.show_price==1'>
                <template v-if="booking == 1">
                  <div class='properties-item__price'>
                    <span class='properties-item__price-value' v-if="property.booking_period == 1">€ {{ property.ah_day_price && property.ah_day_price.indexOf(',00') == -1 ? (property.ah_day_price.indexOf(',') != -1 ? property.ah_day_price : property.ah_day_price + ',-') : (property.ah_day_price ? property.ah_day_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                    <span class='properties-item__price-value' v-else-if="property.booking_period == 2">€ {{ property.ah_week_price && property.ah_week_price.indexOf(',00') == -1 ? (property.ah_week_price.indexOf(',') != -1 ? property.ah_week_price : property.ah_week_price + ',-') : (property.ah_week_price ? property.ah_week_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                    <span class='properties-item__price-value' v-else>€ {{ property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                    <span class='properties-item__price-note' v-if="property.booking_period == 1">{{ locales.property && locales.property.a_day }}</span>
                    <span class='properties-item__price-note' v-else-if="property.booking_period == 2">{{ locales.property && locales.property.a_week }}</span>
                    <span class='properties-item__price-note' v-else>{{ locales.properties && locales.properties.a_month }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class='properties-item__price'>
                    <span class='properties-item__price-value'>€ {{ property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '') }} {{property.ah_price_includes_short}}</span>
                    <span class='properties-item__price-note'>{{ locales.properties && locales.properties.a_month }}</span>
                  </div>
                </template>
              </template>
              <template v-else-if='this.location.href.indexOf("staffhousing")==-1'>
                <div class='properties-item__price'>
                  <span class='properties-item__price-value'>{{locales.properties && locales.properties.price_on_request}}</span>
                </div>
              </template>
              <template v-else>
                <div class='properties-item__price'>
                  <span class='properties-item__price-value'>{{locales.properties && locales.properties.max_number_of_persons}} {{ property.max_people }}</span>
                </div>
              </template>
            </div>
            <div class='properties-item__bottom'>
              <div class='properties-item__parameters'>
                <div class='properties-item__parameters-item'>
                  <i class='icon-ruler'></i>
                  {{property.area}} m&#178;
                </div>
                <div class='properties-item__parameters-item'>
                  <i class='icon-bed'></i>
                  {{ property.no_bedrooms }}
                </div>
                <div class='properties-item__parameters-item'>
                  <i class='icon-furniture'></i>
                  {{ property.furnishing_object ? property.furnishing_object.value : '-' }}
                </div>
              </div>
              <a :href='property.url' class='theme-btn theme-btn--small theme-btn--theme'>
                {{locales.common && locales.common.view_more}}
                <i class='icon-go-right'></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class='properties-listing__empty'>
        <div class='properties-listing__empty-icon-holder'>
          <i class='icon-home properties-listing__empty-icon'/>
        </div>
        <div class='properties-listing__empty-title'>{{locales.properties && locales.properties.no_properties}}</div>
        <div class='properties-listing__empty-text'>{{locales.properties && locales.properties.try_reset_filters}}</div>
        <a class='theme-btn theme-btn--tertiary' @click='resetFilters'>
          <i class='icon-replay' style='font-size: 20px;'/>
          {{locales.properties && locales.properties.reset_filters}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters(['metadata', 'locales']),
      layout() {
        return this.$store.getters.getPropertiesLayout;
      },
      properties() {
        return this.$store.getters.getPropertiesCollection;
      },
      isGrid: function() {
        return this.$store.getters.getPropertiesIsGrid;
      },
      isList: function() {
        return this.$store.getters.getPropertiesIsList;
      },
    },
    props: {
      lang: {
        default: '',
        type: String,
      },
      site: {
        default: '',
        type: String,
      },
      booking: {
        default: 0,
        type: Number,
      },
    },
    methods: {
      resetFilters() {
        window.location.search = '';
      },
    }
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/PropertiesListing.vue